/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ControlTriggerType {
    Base = '0',
    Stepped = 2,
    OutOfRange = 3,
}
